export const tiers = [
  {
    title: 'Starter',
    sub: 'For single applications',
    description:
      'First time users running GameDays on a single application. Unlocks all experiment types for one Team.',
    features: [
      '1 Team',
      '5 Installed Agents',
      'Unlimited Attacks per Target',
      '5 Attacked Targets per month',
      'Community support'
    ]
  },
  {
    title: 'Pro',
    sub: 'For small organizations',
    description:
      'For small organizations with a limited number of Teams and applications. Adds security controls and compliance.',
    features: [
      '3 Teams',
      'Unlimited Agents',
      'Unlimited Attacks per Target',
      '30 Attacked Targets per week',
      'Basic 8-8, M-F support'
    ]
  },
  {
    title: 'Enterprise',
    sub: 'For mid-large organizations',
    description:
      'Mid and large organizations with multiple Teams running and automating experiments. Includes security controls and production support.',
    features: [
      '5 Teams',
      'Unlimited Agents',
      'Unlimited Attacks per Target',
      '50 Attacked Targets per day',
      'Dedicated 24/7 support'
    ]
  }
]
